const isPro=Object.is(process.env.NODE_ENV,'development')
module.exports={
  baseUrl:isPro?'/api':' '
}